import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
  useLocation
} from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Home from './routes/Home';
import Invitation from './routes/Invitation';
import KpgaInvitation from './routes/KpgaInvitation';
import { backendURL } from './common/api';

import './translations';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export { backendURL };

const theme = createTheme({
});

const pageShellSx = {
  minHeight: '100vh',
  backgroundColor: 'var(--s-oil-bg-bottom)',
  backgroundImage: 'none',
};

const kpgaPageShellSx = {
  minHeight: '100vh',
  backgroundColor: '#202020',
  backgroundImage: 'radial-gradient(ellipse at top, #35322a 0%, #202020 58%)',
};

const centeredStageSx = {
  width: '100%',
  maxWidth: '1600px',
  mx: 'auto',
};

function RouterWrapped() {
  const location = useLocation();
  const query = useQuery();
  const participantHash = query.get('hash')
  const [participantInfo, setParticipantInfo] = React.useState(undefined);

  React.useEffect(() => {
    document.title = location.pathname.startsWith('/kpga/')
      ? 'KPGA TOUR CHAMPIONSHIP in Jeju'
      : 'The 20th S-OIL CHAMPIONSHIP';
  }, [location.pathname]);

  React.useEffect(() => {
    if (participantHash && !location.pathname.startsWith('/kpga/')) {
      fetch(`${backendURL}s-oil-api/participants/${participantHash}`, {
        method: "GET",
        headers: {
          'content-type': 'application/json',
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json()
        })
        .then(response => {
          setParticipantInfo(response);
        })
        .catch(error => {
          console.error('Error:', error);
        })
    }
  }, [participantHash, location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Switch>
        <Route path="/kpga/:programType">
          <Box sx={kpgaPageShellSx}>
            <Container component="main" maxWidth="md" sx={{ py: { xs: 2, sm: 4 } }}>
              <KpgaInvitation />
            </Container>
          </Box>
        </Route>
        <Route exact path="/my">
          <Box sx={pageShellSx}>
            <Box sx={centeredStageSx}>
              <Container component="main" maxWidth={false} disableGutters sx={{ px: { xs: '16px', sm: '24px', md: '32px' }, pt: { xs: '12px', sm: '16px', md: '24px' }, pb: { xs: '16px', md: '24px' } }}>
                <Invitation participantHash={participantHash || undefined} />
              </Container>
            </Box>
          </Box>
        </Route>
        <Route path="/">
          <Box sx={pageShellSx}>
            <Container component="main" sx={{ minHeight: '100vh', height: '100vh', overflow: 'hidden', px: { xs: '16px', sm: '24px' }, py: 0 }} maxWidth="md">
              <Home participantInfo={participantInfo} participantHash={participantHash || undefined} />
            </Container>
          </Box>
        </Route>
      </Switch>
    </ThemeProvider >
  )
}

function App() {
  return (
    <BrowserRouter>
      <RouterWrapped />
    </BrowserRouter>
  );
}

export default App;
